import {useEffect} from 'react';
import {useDispatch} from "react-redux";

//saga로 받아둔 데이터를 파라미터 기준으로 재사용한다.
//탭을 옮겼다 돌아올 때마다 같은 요청을 다시 보내던 것을 막기 위함.
//store에 마지막으로 받은 requestKey와 시각을 남겨두고, 둘 다 유효하면 dispatch를 건너뛴다.
const DEFAULT_STALE_TIME = 5 * 60 * 1000;

const useCachedFetch = ({
                            type,
                            requestKey,
                            payload,
                            loadedKey,
                            fetchedAt,
                            enabled = true,
                            staleTime = DEFAULT_STALE_TIME,
                        }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (!enabled || !requestKey) return;

        const isSameParams = loadedKey === requestKey;
        const isFresh = Date.now() - (fetchedAt || 0) < staleTime;
        if (isSameParams && isFresh) return;

        dispatch({
            type,
            data: {...payload, requestKey},
        });
        //payload는 requestKey에서 파생되므로 deps에 넣지 않는다.
        //(매 렌더 새 객체라 넣으면 무한 요청이 된다)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type, requestKey, loadedKey, fetchedAt, enabled, staleTime]);
};

export default useCachedFetch;
